import { render, staticRenderFns } from "./CreateOrderForm.vue?vue&type=template&id=1c6fbb90&"
import script from "./CreateOrderForm.vue?vue&type=script&lang=js&"
export * from "./CreateOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports